var module = angular.module('octopusApp.master');

module.directive('pageBanners', function(octopusPermissionSet, octopusRepository, pollLoop, octopusAuthenticator, octopusLog, $location, $rootScope) {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/master/views/page-banners.html',
    scope: {},
    controller: function ($scope) {
      var refreshStatus = function() {
        return octopusRepository.ServerStatus.getServerStatus().then(function(status){
          $scope.isInMaintenanceMode = status.IsInMaintenanceMode;
        });
      };

      var loop = pollLoop.create($scope, function(){
        return refreshStatus();
      }, { normalTimeout: 10000, disableLongTimeout: true});
      loop.startImmediately();
    }
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/master/directives/page_banners.js
// module id = 630340875754889
// module chunks = 1